export default __webpack_public_path__ + "static/media/tool-icon-cone-low-orange.dc40b476.svg";